import { Container } from "react-bootstrap";
import { useEffect } from 'react';
import { Banner } from '@veeyaainnovatives/banner';
import Bannerimg from '../assets/images/gallery/gallery-3.jpg';

const TermsAndConditions = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const pageDetails = {
        title: "Terms and **Conditions**",
        description: "Please read these terms and conditions carefully before using our services.",
        breadcrumb: [
            { name: "Home", link: "/" },
            { name: "Terms and Conditions", link: "/terms-and-conditions" }
        ],
    };

    return (
        <>
            <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
            <div className="body-wrap overflow-hidden mt-5">
                <section className='py-5'>
                    <Container>
                        <div className="terms-content">
                            <h2 className="mb-4">Terms and Conditions</h2>
                            <p className="text-muted mb-4">Last updated: {new Date().toLocaleDateString()}</p>

                            <div className="mb-5">
                                <h3 className="mb-3">1. Acceptance of Terms</h3>
                                <p>
                                    By accessing and using the services of Sathiesh Design Studio (SDS), you accept and agree to be bound by the terms and conditions set forth below. If you do not agree to these terms, please do not use our services.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">2. Services</h3>
                                <p>
                                    Sathiesh Design Studio provides architecture, interior design, construction, plan approval, structural design, MEP design, 3D VR/AR, estimation, and 3D laser scanning services. All services are subject to availability and our professional assessment of project feasibility.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">3. Project Scope and Agreements</h3>
                                <p>
                                    All projects will be governed by a written agreement that outlines the scope of work, timelines, payment terms, and deliverables. Any changes to the original scope must be agreed upon in writing by both parties.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">4. Payment Terms</h3>
                                <p>
                                    Payment terms will be specified in the project agreement. Payments are typically structured in milestones. Late payments may result in project delays or suspension of services. All prices are subject to change without notice until a formal agreement is signed.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">5. Intellectual Property</h3>
                                <p>
                                    All designs, drawings, plans, and other intellectual property created by SDS remain the property of SDS until full payment is received. Upon full payment, clients receive usage rights for the specific project. SDS retains the right to use project images and designs for portfolio and marketing purposes.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">6. Approvals and Compliance</h3>
                                <p>
                                    While SDS assists with plan approvals and ensures designs comply with local building codes and regulations, final approval from relevant authorities (CMDA, DTCP, etc.) is subject to their discretion. SDS is not liable for delays or rejections by approval authorities beyond our control.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">7. Project Timelines</h3>
                                <p>
                                    Project timelines are estimates based on current workload and client responsiveness. Delays caused by client indecision, late approvals, or changes in scope may extend project timelines. SDS will communicate any significant delays promptly.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">8. Limitation of Liability</h3>
                                <p>
                                    SDS's liability is limited to the value of fees paid for the specific service. SDS is not liable for indirect, consequential, or incidental damages. While we strive for accuracy, clients are responsible for verifying all designs and plans before construction.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">9. Cancellation and Refunds</h3>
                                <p>
                                    Cancellation policies will be outlined in the project agreement. Refunds, if applicable, will be calculated based on work completed and expenses incurred. No refunds will be provided for completed work or services already delivered.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">10. Client Responsibilities</h3>
                                <p>
                                    Clients are responsible for providing accurate information, timely decisions, necessary approvals, site access, and compliance with local regulations. Delays caused by client actions may result in additional charges.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">11. Confidentiality</h3>
                                <p>
                                    SDS maintains confidentiality of client information and project details. Client data will not be shared with third parties without consent, except as required by law or for project execution purposes.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">12. Dispute Resolution</h3>
                                <p>
                                    Any disputes will first be addressed through direct communication. If unresolved, disputes will be subject to the jurisdiction of courts in Chennai, Tamil Nadu, India.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">13. Modifications to Terms</h3>
                                <p>
                                    SDS reserves the right to modify these terms and conditions at any time. Continued use of our services after changes constitutes acceptance of the modified terms.
                                </p>
                            </div>

                            <div className="mb-5">
                                <h3 className="mb-3">14. Contact Information</h3>
                                <p>
                                    For questions about these terms and conditions, please contact us through our website or at the contact information provided on our Contact Us page.
                                </p>
                            </div>

                            <div className="alert alert-info mt-5">
                                <strong>Note:</strong> These terms and conditions are general guidelines. Specific project terms will be detailed in individual project agreements.
                            </div>
                        </div>
                    </Container>
                </section>
            </div>
        </>
    );
};

export default TermsAndConditions;

